import moment from 'moment'

import {
  C_SET_TOKEN,
  C_SET_PASSENGER_TOKEN,
  C_INVALIDATE_TOKEN,
  C_INVALIDATE_PASSENGER_TOKEN,
  C_RENEW_TOKEN,
  C_SET_SIGNED_IN_USER,
  C_SET_SIGNED_USER_PROMISE
} from '../utilities/mutation-types'

const LOCAL_STORAGE_PREFIX = 'st_'

function getToken (state) {
  if (!state.accessToken) {
    const accessToken = localStorage.getItem(LOCAL_STORAGE_PREFIX + 'accessToken')

    if (accessToken) {
      state.accessToken = JSON.parse(accessToken)
    }
  }

  return state.accessToken
}

function getTokenId (state) {
  const accessToken = getToken(state)

  if (accessToken) {
    return accessToken.id
  }
}

function getPassengerAuthorizationToken (state) {
  if (!state.passengerAuthorizationToken) {
    const passengerAuthorizationToken = localStorage.getItem(LOCAL_STORAGE_PREFIX + 'passengerAuthorizationToken')

    if (passengerAuthorizationToken) {
      state.passengerAuthorizationToken = JSON.parse(passengerAuthorizationToken)
    }
  }

  if (state.passengerAuthorizationToken?.expires <= Date.now()) {
    state.passengerAuthorizationToken = null
  }

  return state.passengerAuthorizationToken
}

export default {
  state: {
    user: null,
    userPromise: null,
    accessToken: null,
    passengerAuthorizationToken: null
  },
  getters: {
    tokenId: getTokenId,
    token: getToken,
    user: (state) => state.user,
    passengerAuthorizationToken: getPassengerAuthorizationToken
  },
  mutations: {
    [C_SET_TOKEN] (state, { newAccessToken }) {
      if (newAccessToken) {
        const expireDate = moment.utc(newAccessToken.created).add(newAccessToken.ttl, 'seconds')
        newAccessToken.expires = expireDate.valueOf()
        newAccessToken.renews = expireDate.subtract(Math.ceil(newAccessToken.ttl / 2), 'seconds').valueOf()
      }
      state.accessToken = newAccessToken
      localStorage.setItem(LOCAL_STORAGE_PREFIX + 'accessToken', newAccessToken ? JSON.stringify(newAccessToken) : '')
    },
    [C_SET_PASSENGER_TOKEN] (state, { newPassengerToken }) {
      if (newPassengerToken) {
        const expireDate = moment.utc(newPassengerToken.dateCreated).add(newPassengerToken.ttl, 'seconds')
        newPassengerToken.expires = expireDate.valueOf()
      }
      state.passengerAuthorizationToken = newPassengerToken
      localStorage.setItem(LOCAL_STORAGE_PREFIX + 'passengerAuthorizationToken', newPassengerToken ? JSON.stringify(newPassengerToken) : '')
    },
    [C_SET_SIGNED_IN_USER] (state, { newUser }) {
      state.user = newUser
    },
    [C_SET_SIGNED_USER_PROMISE] (state, { promise }) {
      state.userPromise = promise
    },
    [C_RENEW_TOKEN] (state, { newAccessToken }) {
      state.accessToken.created = newAccessToken.created
      state.accessToken.ttl = newAccessToken.ttl
      const expireDate = moment.utc(newAccessToken.created).add(newAccessToken.ttl, 'seconds')
      state.accessToken.expires = expireDate.valueOf()
      state.accessToken.renews = expireDate.subtract(Math.ceil(newAccessToken.ttl / 2), 'seconds').valueOf()
      localStorage.setItem(LOCAL_STORAGE_PREFIX + 'accessToken', JSON.stringify(state.accessToken))
    },
    [C_INVALIDATE_TOKEN] (state) {
      state.accessToken = null
      localStorage.setItem(LOCAL_STORAGE_PREFIX + 'accessToken', '')
      localStorage.removeItem(LOCAL_STORAGE_PREFIX + 'accessToken')
    },
    [C_INVALIDATE_PASSENGER_TOKEN] (state) {
      state.passengerAuthorizationToken = null
      localStorage.setItem(LOCAL_STORAGE_PREFIX + 'passengerAuthorizationToken', '')
      localStorage.removeItem(LOCAL_STORAGE_PREFIX + 'passengerAuthorizationToken')
    }
  }
}
